import { render, staticRenderFns } from "./TournamentListCardFooter.vue?vue&type=template&id=3b80c36d&"
import script from "./TournamentListCardFooter.vue?vue&type=script&lang=ts&"
export * from "./TournamentListCardFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardActions})
